export enum FormsEvents {
    name = 'nome_invalido',
    term = 'desmarcou_aceite_contrato',
    endereco = 'erro_upload_docs_comprovante_endereco',
    docVerso = 'erro_upload_docs_cnh_rg_verso',
    birthDate = 'data_invalida_nascimento',
    docFrente = 'erro_upload_docs_cnh_rg_frente',
    motherName = 'nome_invalido_da_mae',
    fatherName = 'nome_invalido_do_pai',
    titularCard = 'erro_upload_cartao_credito_cotitular',
    chequeImage = 'erro_upload_cheque_cotitular',
    erroServidor = 'erro_servidor',
    coTitularCard = 'erro_upload_cartao_debito_cotitular',
    monthlySalary = 'informe_salario_bruto',
    conjugeCPFImage = 'erro_upload_cpf_cotitular',
    jointHolderName = 'nome_invalido_cotiular',
    usuarioCadastrado = 'usuario_cadastrado',
    exibidoPrimeiroPasso = 'exibido_o_primeiro_passo',
    movablePropertiesValue = 'informe_renda_e_patrimonio',
    jointHolderDocumentNumber = 'esse_cpf_nao_existe_cotitular',
    identificationDocumentIssuedDate = 'data_invalida_documento_emissao',
    identificationDocumentExpirationDate = 'data_invalida_documento_validade',
    brokerageToroZero = 'corretagem_toro_zero',
    brokerageWinwin = 'corretagem_ganha_ganha',
}

export enum FormsEventType  {
    Modal = 'Modal',
    Error = 'Erro',
    Success = 'Sucesso',
    Brokerage = 'CorretagemSelecionada',
}
